import { ApiQueries, DaymapIcon, DaymapIconType, FileItem, NoItems, useStudent, DaymapSkeleton } from "daymap-react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { PageContainer, PageDescriptor } from "../../../components/layout";

function Reports() {
    const {studentId} = useParams();
    const student = useStudent(Number(studentId));

    const { isPending, data } = new ApiQueries.files.FileList({FileType: 7, LinkID:Number(studentId)}).ToQuery();
    
    if (isPending) {
        return <PageContainer>
            <DaymapSkeleton type="page" />
        </PageContainer>
    }

    return (
        <PageContainer>
            <PageDescriptor icon={<DaymapIcon iconType={DaymapIconType.Report} />} title="Reports" >
                Download {student?.Displayname}'s published report documents
            </PageDescriptor>
            {data?.length== 0 &&
                <NoItems >
                    There are no documents for this student
                </NoItems>
            }
            {(data?.length ?? 0) > 0 &&
                <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                    {data?.map((file) => {
                        return (
                            <FileItem key={file.FileID} name={file.FullName} 
                            description={file.Description} 
                            extension={file.Ext} 
                            modified={file.Modified} 
                            download
                            contentType={4}
                            fileId={file.FileID}
                            pdf={file.Ext.toLowerCase() == "pdf"}
                        />)})
                    }
                </Box>
            }
        </PageContainer>
    )
}

export default Reports;